import { useEffect } from 'react'
import { post } from '../api'
import { useAccount } from './useAccount'
import { useQuery } from '@tanstack/react-query'

const LOCATION_TRACK_KEY = 'rushb-last-location-track-timestamp'
const HALF_DAY_MS = 12 * 60 * 60 * 1000

export function useTrackLocation() {
  const { isLogin } = useAccount()
  const lastCall = Number(localStorage.getItem(LOCATION_TRACK_KEY) || '0')
  const now = Date.now()
  const shouldFetch = isLogin && now - lastCall >= HALF_DAY_MS

  useQuery({
    queryKey: ['track-location'],
    queryFn: async () => {
      await post('/v1/skinsyard/facade/user/save_location')
    },
    enabled: shouldFetch,
    refetchInterval: HALF_DAY_MS,
    refetchIntervalInBackground: true,
    retry: 1,
  })

  useEffect(() => {
    return () => {
      localStorage.setItem(LOCATION_TRACK_KEY, Date.now().toString())
    }
  }, [])
}
